"use client"

import { useInView } from "react-intersection-observer"

import { ShoppingCart, Truck, Users, TrendingUp } from "lucide-react"
import "../assets/css/upcoming-projects.css"
import greenHomeImg from "../assets/images/greenhome.webp"

export default function UpcomingProjects() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  })

  return (
    <section id="upcoming" ref={ref} className="upcoming-projects-section">
      <div className="upcoming-container">
        <div className="section-header">
          <h2 className={`section-title ${inView ? "visible" : ""}`}>Coming Soon</h2>
          <div className={`section-divider ${inView ? "visible" : ""}`}></div>
          <p className={`upcoming-subtitle ${inView ? "visible" : ""}`}>
            Revolutionary retail concept bringing fresh vegetables directly from farm to your table
          </p>
        </div>

        <div className="upcoming-content">
          <div className={`upcoming-main ${inView ? "visible" : ""}`}>
            <div className="upcoming-image">
              <img src={greenHomeImg} alt="Green Home Supermarket"  className="image-soon" />
              <div className="coming-soon-badge">
                <span>Coming Soon</span>
              </div>
            </div>

            <div className="upcoming-info">
              <h3 className="upcoming-title">Green Home Supermarket Chain</h3>
              <p className="upcoming-tagline">Fresh Vegetables at Wholesale Prices</p>
              <p className="upcoming-description">
                We're excited to announce our upcoming retail venture - a chain of Green Home supermarkets that will
                revolutionize how you buy fresh vegetables. By eliminating middlemen and sourcing directly from our
                farms and partner farmers, we'll offer premium quality fresh vegetables at wholesale prices to everyday
                consumers.
              </p>

              <div className="upcoming-features">
                <div className="upcoming-feature">
                  <div className="feature-icon">
                    <ShoppingCart className="icon-svg" />
                  </div>
                  <div className="feature-content">
                    <h4>Wholesale Prices</h4>
                    <p>Direct from farm pricing for all customers</p>
                  </div>
                </div>

                <div className="upcoming-feature">
                  <div className="feature-icon">
                    <Truck className="icon-svg" />
                  </div>
                  <div className="feature-content">
                    <h4>Farm Fresh Daily</h4>
                    <p>Daily deliveries ensuring maximum freshness</p>
                  </div>
                </div>

                <div className="upcoming-feature">
                  <div className="feature-icon">
                    <Users className="icon-svg" />
                  </div>
                  <div className="feature-content">
                    <h4>Community Focus</h4>
                    <p>Supporting local farmers and communities</p>
                  </div>
                </div>

                <div className="upcoming-feature">
                  <div className="feature-icon">
                    <TrendingUp className="icon-svg" />
                  </div>
                  <div className="feature-content">
                    <h4>Quality Guarantee</h4>
                    <p>Rigorous quality control and freshness standards</p>
                  </div>
                </div>
              </div>

              {/* <div className="upcoming-timeline">
                <h4>Launch Timeline</h4>
                <div className="timeline-items">
                  <div className="timeline-item">
                    <div className="timeline-marker active"></div>
                    <div className="timeline-content">
                      <h5>Site Selection</h5>
                      <p>Q1 2024 - Completed</p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-marker active"></div>
                    <div className="timeline-content">
                      <h5>Store Design</h5>
                      <p>Q2 2024 - In Progress</p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                      <h5>Construction</h5>
                      <p>Q3 2024 - Upcoming</p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                      <h5>Grand Opening</h5>
                      <p>Q4 2024 - Target</p>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* <div className="upcoming-cta">
                <button className="notify-button">Notify Me When We Launch</button>
                <p className="cta-text">Be the first to know when we open our doors!</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="bg-veggie bg-veggie-1"></div>
      <div className="bg-veggie bg-veggie-2"></div>
    </section>
  )
}
